'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTimestamp = exports.setThreadId = exports.setStatus = exports.setSource = undefined;

var _setIn = require('transmute/setIn');

var _setIn2 = _interopRequireDefault(_setIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setSource = exports.setSource = (0, _setIn2.default)(_keyPaths.DESCRIPTOR_SOURCE);
var setStatus = exports.setStatus = (0, _setIn2.default)(_keyPaths.DESCRIPTOR_STATUS);
var setThreadId = exports.setThreadId = (0, _setIn2.default)(_keyPaths.THREAD_ID);
var setTimestamp = exports.setTimestamp = (0, _setIn2.default)(_keyPaths.TIMESTAMP);